<template>
  <div>
    <br />
    <h5 class="text-muted text-center">
      {{ message }}
    </h5>
  </div>
</template>
<script>
import i18n from 'src/i18n';
export default {
  name: 'not-index-permissions',

  props: {
    operationType: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    message() {
      switch (this.operationType) {
        case 'visualize':
          return i18n.t('common_words.no_permissions');
        case 'create':
          return i18n.t('common_words.no_permissions_creation');
        case 'edit':
          return i18n.t('common_words.no_permissions_edit');
        case 'operation':
          return i18n.t('common_words.no_permissions_operations');
        default:
          return i18n.t('common_words.no_permissions');
      }
    },
  },
};
</script>
